import React from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import heroImg from '../../assets/image/img-1.jpg';
const Hero = ({ data }) => {
    return (
        <div className="page-title-home">
            <div className="mask mask-home-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                    <circle cx="400" cy="400" r="325" stroke="url(#a)" strokeWidth="150" />
                    <defs>
                        <linearGradient id="a" x1="176" x2="569" y1="70.5" y2="674">
                            <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                            <stop offset="1" stopColor="#fff" stopOpacity="0" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div className="mask mask-home-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                    <circle cx="400" cy="400" r="325" stroke="url(#a1)" strokeWidth="150" />
                    <defs>
                        <linearGradient id="a1" x1="176" x2="569" y1="70.5" y2="674">
                            <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                            <stop offset="1" stopColor="#fff" stopOpacity="0" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div className="tf-container">
                <div className="row">
                    <div className="col-12">
                        <div className="top-page-title">
                            <div
                                className="sub-title body-2 fw-5 split-text effect-right"
                                dangerouslySetInnerHTML={{ __html: data?.top_title || 'Welcome to WMK TECH Software Company ' }}
                            />
                            <h1
                                className="title fw-6 lh-85 split-text effect-right"
                                dangerouslySetInnerHTML={{ __html: data?.main_title || 'Bespoke software solutions <br /> <span class="fw-3">your <span class="highlight text-uppercase">unique business</span> needs</span>' }}
                            />
                        </div>
                    </div>
                </div>
                <div className="row justify-content-between rg-70">
                    <div className="col-lg-4">
                        <div className="content-left">

                            <div
                                className="desc text-animation"
                                dangerouslySetInnerHTML={{
                                    __html: data?.description || `<p class="fs-20 lh-40">We are a team of highly motivated and skilled developers dedicated to delivering only the best software.</p>`
                                }}
                            />

                            <div className="wg-counter flex align-items-center justify-content-between">

                                <div className="counter-item">
                                    <div className="counter">
                                        <div className="number-counter flex fs-65 fw-6">
                                            <span className="number color-primary">
                                                <CountUp
                                                    key={data?.counter_one}
                                                    end={parseInt(data?.counter_one) || 3}
                                                    duration={3}
                                                    enableScrollSpy
                                                    scrollSpyOnce
                                                />
                                            </span>
                                            <span className="color-primary">
                                                {data?.counter_one ? data.counter_one.toString().replace(/[0-9]/g, '') : 'k'}+
                                            </span>
                                        </div>
                                        <p className="title-counter body-2 lh-30">
                                            Happy Clients
                                        </p>
                                    </div>
                                </div>

                                <div className="counter-item">
                                    <div className="counter">
                                        <div className="number-counter flex fs-65 fw-6">
                                            <span className="number color-primary">
                                                <CountUp
                                                    key={data?.counter_two}
                                                    end={parseInt(data?.counter_two) || 20}
                                                    duration={3}
                                                    enableScrollSpy
                                                    scrollSpyOnce
                                                />
                                            </span>
                                            <span className="color-primary">
                                                {data?.counter_two ? data.counter_two.toString().replace(/[0-9]/g, '') : ''}+
                                            </span>
                                        </div>
                                        <p className="title-counter body-2 lh-30">
                                            Years Experience
                                        </p>
                                    </div>
                                </div>

                            </div>

                            <Link to="/" state={{ scrollTo: 'about' }} className="tf-btn">
                                <span>Learn more</span>
                                <i className="icon-arrow-right"></i>
                            </Link>
                        </div>

                    </div>
                    <div className="col-lg-7">
                        <div className="image tf-animate-1">
                            <img src={data?.image ? (data.image.startsWith('http') ? data.image : `${process.env.REACT_APP_STORAGE_BASE_URL || 'http://localhost:8000/storage'}/${data.image}`) : heroImg} alt="Hero" />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Hero;
